<template>
  <x-page
    :loading="loading"
    :white-back="true"
    :title-adaptive="true"
    :transparent-header="true"
    :enable-header-parallax="true"
  >
    <template v-if="!loading" #header="{ headerParallaxRate, handleBackClick }">
      <div
        class="header"
        :style="{
          backgroundColor:
            headerParallaxRate === 0
              ? 'transparent'
              : `rgba(255, 255, 255, ${headerParallaxRate})`,
        }"
      >
        <!-- 返回 -->
        <van-icon
          name="arrow-left"
          class="back"
          :style="{
            color:
              headerParallaxRate === 0
                ? 'white'
                : `rgba(0, 0, 0, ${headerParallaxRate})`,
          }"
          @click="handleBackClick"
        />
        <!-- 搜索 -->
        <div
          v-track="{
            name: '首页-搜索框',
          }"
          class="search"
          :style="{
            backgroundColor:
              headerParallaxRate === 0
                ? 'rgba(255, 255, 255, 0.2)'
                : `rgba(245, 245, 245, ${headerParallaxRate})`,
            color:
              headerParallaxRate === 0
                ? `white`
                : `rgba(0, 0, 0, ${headerParallaxRate})`,
          }"
          @click="handleSearchClick"
        >
          <div class="icon">
            <svg
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              width="1em"
              height="1em"
            >
              <path
                d="M959.52557 843.97588 783.748171 702.726879c35.867906-58.81964 56.906058-127.674844 56.906058-201.608717 0-214.430744-173.829024-388.262838-388.260791-388.262838S64.132646 286.687418 64.132646 501.118162s173.829024 388.262838 388.260791 388.262838c122.906238 0 232.272088-57.267285 303.416428-146.394185l173.10964 139.091872L959.52557 843.97588zM452.393437 840.48743c-187.126888 0-339.367221-152.240333-339.367221-339.368244s152.240333-339.368244 339.367221-339.368244 339.367221 152.240333 339.367221 339.368244S639.520325 840.48743 452.393437 840.48743z"
              ></path>
            </svg>
          </div>
          <div class="text">{{ searchData.defaultKeyWord }}</div>
        </div>
      </div>
    </template>
    <template v-if="!loading">
      <!-- 头图 -->
      <div
        v-track="{
          name: '首页-消费券入口',
        }"
        class="headImage"
        @click="handleHeadImageClick"
      >
        <img
          :src="require('./images/消费券商城/消费券头图.png')"
          class="cover"
        />
        <x-lottie
          :data="import('./images/消费券商城/头图按钮_动.json')"
          class="button"
        />
      </div>

      <!-- 金刚区 -->
      <div class="service">
        <div
          v-for="(item, index) in homeData.fixedService"
          :key="item.id"
          v-track="{
            name: '首页-金刚区',
            resource: item,
            index: index,
          }"
          class="item"
          @click="$handleResourceClick(item)"
        >
          <img :src="item.icon" class="icon" />
          <div class="label">{{ item.title }}</div>
        </div>
      </div>

      <!-- 5G专场 -->
      <div
        v-if="homeData.fivegService.length"
        class="g5"
        :style="{
          backgroundImage: `url(${require('./images/消费券商城/通信背景图.png')})`,
        }"
      >
        <div class="hd">
          <div class="title">5G专场</div>
          <div class="desc">流量不够用？秒充值秒到账</div>
        </div>
        <div class="bd">
          <div
            v-for="(item, index) in homeData.fivegService.slice(0, 2)"
            :key="item.id"
            v-track="{
              name: '首页-三大运营商商城入口',
              resource: item,
              index: index,
            }"
            class="item"
            @click="$handleResourceClick(item)"
          >
            <img :src="item.icon" class="icon" />
          </div>
        </div>
      </div>

      <!-- 广告 1 -->
      <div
        v-if="homeData.travelAd.length"
        v-track="{
          name: '首页-游遍贵州广告位',
          resource: homeData.travelAd[0],
        }"
        class="ad_1"
        :style="{ backgroundImage: `url(${homeData.travelAd[0].icon})` }"
        @click="$handleResourceClick(homeData.travelAd[0])"
      />

      <!-- 广告 -->
      <div v-if="homeData.hotRecommend" class="ad">
        <div
          class="hd"
          :style="{
            backgroundImage: `url(${require('./images/消费券商城/广告头部背景图.png')})`,
          }"
        >
          <div class="title">人气精选</div>
        </div>
        <div class="bd">
          <x-carousel
            v-if="homeData.hotRecommend.mainAd.length"
            :data="homeData.hotRecommend.mainAd"
            class="ad1"
          >
            <template #item="{ item, index }">
              <img
                v-track="{
                  name: '首页-广告模块-主广告',
                  resource: item,
                  index: index,
                }"
                :src="item.image"
              />
            </template>
          </x-carousel>
          <div v-if="homeData.hotRecommend.subAd.length" class="ad2">
            <div
              v-for="(item, index) in homeData.hotRecommend.subAd"
              :key="item"
              v-track="{
                name: '首页-广告模块-副广告',
                resource: item,
                index: index,
              }"
              class="item"
              @click="$handleResourceClick(item)"
            >
              <img :src="item.icon" class="cover" />
              <div :class="['title', _._ellipsis]">{{ item.title }}</div>
              <div class="button">去看看</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 商品 -->
      <div
        v-if="
          homeData.boutiqueRecommend.length ||
          homeData.commodityRecommend.length
        "
        class="goods"
      >
        <div class="title">
          <div class="text">优选品牌</div>
          <div class="desc">消费券全场通用</div>
        </div>
        <div v-if="homeData.boutiqueRecommend.length" class="recommend">
          <x-carousel :data="homeData.boutiqueRecommend" class="carousel">
            <template #item="{ item, index }">
              <img
                v-track="{
                  name: '首页-精选好物-广告',
                  resource: item,
                  index: index,
                }"
                :src="item.image"
              />
            </template>
          </x-carousel>
        </div>
        <div
          v-if="homeData.commodityRecommend.length"
          v-masonry="'首页商品列表'"
          class="list"
          transition-duration="0"
          item-selector=".homeGoodsItem"
        >
          <div
            v-for="(item, index) in homeData.commodityRecommend"
            :key="item.id"
            v-masonry-tile
            v-track="{
              name: `首页-精选好物-商品`,
              resource: item,
              index: index,
            }"
            :class="['homeGoodsItem', 'item', $isAdResource(item) && 'link']"
            @click="$handleResourceClick(item)"
          >
            <van-image :src="item.icon" fit="cover" class="cover" lazy-load />
            <template v-if="!$isAdResource(item)">
              <div :class="['name', _._ellipsis2]">
                {{ item.title }}
              </div>
              <div v-if="item.subTitle" :class="['desc', _._ellipsis]">
                {{ item.subTitle }}
              </div>
              <div v-if="$extractTagsFromResource(item).length" class="tags">
                <div
                  v-for="tag in $extractTagsFromResource(item)"
                  :key="tag"
                  class="tag"
                >
                  {{ tag }}
                </div>
              </div>
              <div class="extra">
                <div class="price">¥{{ item.discountAmt }}</div>
                <div class="sold">已售{{ item.sales }}</div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </template>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import {
    apiPageConfigGetDataGzCouponHomeData,
    apiSearchMartSearchFindSceneDetail,
  } from '@/api'
  import { currentMall } from '@/mall'
  import { dcb } from '@dcb/jssdk'
  import { devOrProd, prepareData } from '@/utils'
  import { globalModel } from '@/model'
  import { loadResource, LoadResourceUrlType, range } from 'vtils'
  import { navigateTo } from '@/router'

  export default Vue.extend({
    data: () => ({
      // 页面级加载状态
      loading: true,

      // 首页数据
      homeData: {},

      // 搜索数据
      searchData: {},

      // 当前分类索引
      currentCatIndex: 0,
    }),

    computed: {
      goodsList() {
        return range(1, 25)
      },
    },

    async activated() {
      // 非 cdn 接口不影响主流程
      apiSearchMartSearchFindSceneDetail(
        {
          sceneId: currentMall.mall_home_search_scene_id,
        },
        {
          noErrorToast: true,
        },
      ).then(searchData => {
        this.searchData = searchData
      })

      const { homeData } = await prepareData({
        homeData: apiPageConfigGetDataGzCouponHomeData(
          {},
          {
            useCdnData: devOrProd(
              'https://dcb-resource.duotest.cn/mall-platform/dcb-mall/data-gz-coupon/homedata.json',
              'https://new-resource.gogpay.cn/mall-platform/dcb-mall/data-gz-coupon/homedata.json',
            ),
          },
        ),
        // 预加载头图，防止头部白屏
        homeHeadImage: loadResource({
          type: LoadResourceUrlType.img,
          path: require('./images/消费券商城/消费券头图.png'),
        }),
      })
      this.homeData = homeData
      this.loading = false

      this.$nextTick(() => {
        this.$redrawVueMasonry('首页商品列表')
      })
    },

    methods: {
      // 点击搜索
      handleSearchClick() {
        navigateTo('SearchEntry', {
          q: this.searchData.defaultKeyWord,
          l: JSON.stringify(/* this.searchData.refCategoryIds */ []),
        })
      },

      // 点击头图
      handleHeadImageClick() {
        if (globalModel.state.fromCoupon) {
          dcb.closeWindow()
        } else {
          dcb.navigateTo({
            url: process.env.VUE_APP_COUPON_HOME_URL,
          })
        }
      },
    },
  })
</script>

<style lang="scss" scoped>
  .header {
    background-color: white;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 12px;
    box-sizing: border-box;

    .back {
      flex-shrink: 0;
      font-size: 18px;

      &:active {
        opacity: 0.8;
      }
    }

    .search {
      flex-grow: 1;
      margin: 0 4px 0 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 7px 0;
      border-radius: 1000px;

      .icon {
        flex-shrink: 0;
        font-size: 16px;
        display: inline-flex;

        svg {
          fill: currentColor;
        }
      }

      .text {
        margin-left: 7px;
        font-size: 14px;
      }
    }
  }

  .headImage {
    position: relative;

    .cover {
      width: 100%;
      height: 512px;
    }

    .button {
      position: absolute;
      top: 170px;
      left: -245px;
      width: 216px * 4;
      height: 58px * 4;
    }
  }

  .service {
    position: relative;
    margin-top: -98px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    z-index: 1;

    .item {
      margin-top: 9px;
      width: 25%;
      display: flex;
      flex-direction: column;
      align-items: center;

      .icon {
        width: 54px;
        height: 54px;
      }

      .label {
        margin-top: 4px;
        font-size: 12px;
        color: #222222;
      }

      &:active {
        opacity: 0.9;
      }
    }
  }

  .ad_1 {
    margin: 12px;
    height: 70px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }

  .g5,
  .ad {
    margin: 12px;
    background: #ffffff;
    border-radius: 8px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;

    .hd {
      display: flex;
      align-items: center;
      padding: 12px;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center;

      .title {
        font-size: 18px;
        font-weight: bold;
        color: #222222;
      }

      .desc {
        margin-left: 6px;
        background: linear-gradient(318deg, #fce7b9 0%, #fde8bb 100%);
        font-size: 12px;
        font-weight: bold;
        color: #af5c00;
        padding: 2px 9px 2px 6px;
        border-radius: 110px 110px 110px 2px;
      }
    }

    .bd {
      padding: 0 12px 12px 12px;

      .ad1 {
        width: 100%;
        height: 90px;
        border-radius: 8px;
        object-fit: cover;

        &:active {
          opacity: 0.9;
        }
      }

      .ad2 {
        margin-top: 9px;
        display: flex;
        align-items: center;

        .item {
          flex: 1;
          border-radius: 8px;
          border: 1px solid #e9e9e9;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          align-items: center;

          + .item {
            margin-left: 9px;
          }

          .cover {
            width: 100%;
            height: 77px;
            object-fit: cover;
          }

          .title {
            margin-top: 6px;
            font-size: 14px;
            color: #222222;
            width: 100%;
            padding: 0 4px;
            box-sizing: border-box;
            text-align: center;
          }

          .button {
            margin-top: 6px;
            margin-bottom: 8px;
            background: #ff111c;
            border-radius: 1000px;
            font-size: 12px;
            color: #ffffff;
            padding: 5px 16px;

            &:active {
              opacity: 0.8;
            }
          }
        }
      }
    }
  }

  .g5 {
    .hd {
      .title {
        color: white;
      }
    }

    .bd {
      display: flex;
      align-items: center;

      .item {
        flex: 1;
        border-radius: 12px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 6px;
        overflow: hidden;

        .icon {
          width: 157px;
          height: 94px;
          border-radius: 12px;
          object-fit: cover;
          user-select: none;
        }

        + .item {
          margin-left: 13px;
        }
      }
    }

    .ft {
      padding: 0 12px;

      .item {
        width: 100%;
        height: 48px;
        border-radius: 8px;
        object-fit: cover;
      }
    }
  }

  .goods {
    .title {
      margin: 12px 12px 0 12px;
      display: flex;
      align-items: center;

      .text {
        font-size: 18px;
        font-weight: bold;
        color: #222222;
      }

      .desc {
        margin-left: 8px;
        font-size: 14px;
        color: #888888;
      }
    }

    .recommend {
      margin-top: 12px;
      padding: 0 12px;

      .carousel {
        width: 100%;
        height: 90px;
        border-radius: 8px;
      }
    }

    .list {
      padding: 12px;
      margin-top: -8px;
      margin-left: -6px;

      .item {
        margin-top: 8px;
        margin-left: 6px;
        width: 172px;
        background-color: white;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        overflow: hidden;

        .cover {
          width: 172px;
          height: 172px;
        }

        .name {
          margin: 8px 8px 0 8px;
          font-size: 14px;
          font-weight: bold;
          color: #222222;
          line-height: 18px;
        }

        .desc {
          margin: 5px 8px 0 8px;
          font-size: 12px;
          color: #888888;
        }

        .tags {
          margin: 5px 8px 0 8px;
          display: flex;
          align-items: center;

          .tag {
            background: #fff6e9;
            border-radius: 1000px;
            font-size: 12px;
            color: #ffa021;
            padding: 3px 6px;

            + .tag {
              margin-left: 8px;
            }
          }
        }

        .extra {
          margin: 8px 8px 8px 8px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .price {
            font-size: 16px;
            font-weight: bold;
            color: #ff111c;
          }

          .sold {
            font-size: 12px;
            color: #888888;
          }
        }

        &.link {
          .cover {
            width: 172px;
            height: 243px;
          }
        }
      }
    }
  }
</style>
